export const PageText = {
  _1: 'The best available AQ information',
  _2: 'aircheckr brings air quality information for your exact location, right now!'
};

export const Categories = {
  _1: {
    title: 'Big variations',
    subcategories: [
      {
        key: 0,
        subtitle: 'Air quality changes greatly in space and time',
        text: 'Air pollution next to a highway during rush hour may differ considerably from that in the park 300 meter away. For long there was no real-time data available to reflect these differences. Aircheckr changes this completely with its near real-time & detailed outside air quality information.'
      }
    ]
  },
  _2: {
    title: 'The alternatives',
    subcategories: [
      {
        key: 0,
        subtitle: 'Measuring stations',
        text: 'On the one hand, measuring stations are doing a detailed registrations of several pollutants, but only a limited number of them can be found in a city (in smaller towns and rural areas often even less). But what is the air quality in between these measuring stations, knowing that air quality varies a lot from place to place?'
      },
      {
        key: 1,
        subtitle: 'Other AQ models',
        text: 'Other AQ models exist in some countries (although often not public/open) that give near real-time values for different pollutants, but their spatial resolution is very coarse. More detailed models (up to street level) sometimes exist, but are very computer intensive. Long processing times are required, making these results unavailable for real-time high resolution applications.',
        text_2: 'As a result, the currently available air quality data is often not suitable for personal use or implementation into a business context.'
      }
    ]
  },
  _3: {
    title: 'aircheckr',
    subcategories: [
      {
        key: 0,
        subtitle: 'Opening up a huge amount of possibilities for daily use',
        text: 'aircheckr is detailed, fast, simple to interpret, high-quality and applied, opening up a huge amount of possibilities for daily use by individuals and integration into businesses.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/the-best-available-aq-info_page.js